import MarkdownText from '@/components/markdown/markdown-text';
import useIsMobile from '@/hooks/use-is-mobile';
import { Box, Image } from '@cmpsr/components';
import Stack from '@mui/material/Stack';
import Step from '@mui/material/Step';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { StepIconProps } from '@mui/material/StepIcon';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import { styled } from '@mui/material/styles';
import { text } from '../../../common/theme';

const HorizontalConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 2,
    border: 0,
    backgroundColor: '#183344',
  },
}));

const StepIconWrapper = styled('div')<{
  ownerState: { completed?: boolean; active?: boolean };
}>(({ theme }) => ({
  zIndex: 1,
  width: 44,
  height: 44,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  ...theme.applyStyles('dark', {}),
  variants: [
    {
      props: ({ ownerState }) => ownerState.completed,
      style: {
        backgroundColor: '#183344',
      },
    },
  ],
}));

function StepIcon(props: StepIconProps) {
  const { active, completed, className } = props;

  return (
    <StepIconWrapper ownerState={{ completed, active }} className={className}>
      <Image w="24px" h="24px" src="/images/login.svg" alt="Check" />
    </StepIconWrapper>
  );
}

export function HowItWorksStepper() {
  const isMobile = useIsMobile();

  const steps = [
    { label: 'Learn your risk for **21 top cancers**' },
    { label: 'Build an **optimal screening protocol** based on your risk' },
    { label: 'Discover the simple ways you can **reduce your risk**' },
  ];

  if (isMobile) {
    return <HowItWorksStepperMobile steps={steps} />;
  }

  return (
    <Stack sx={{ width: '100%' }} spacing={4}>
      <Stepper alternativeLabel activeStep={3} connector={<HorizontalConnector />}>
        {steps.map((label) => (
          <Step key={label.label}>
            <StepLabel slots={{ stepIcon: StepIcon }}>
              <MarkdownText maxWidth="250px">{label.label}</MarkdownText>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Stack>
  );
}

const VerticalConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      border: 0,
      width: '2px',
      backgroundColor: '#183344',
      marginLeft: '9px',
    },
  },
}));

export function HowItWorksStepperMobile({ steps }: { steps: { label: string }[] }) {
  return (
    <Box sx={{ maxWidth: 400, marginX: 'auto' }}>
      <Stepper activeStep={3} orientation="vertical" connector={<VerticalConnector />}>
        {steps.map((step, index) => (
          <Step key={step.label}>
            <StepLabel slots={{ stepIcon: StepIcon }}>
              <MarkdownText pl="4" {...text.body.regular}>
                {step.label}
              </MarkdownText>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
